import { Box, FormControl, MenuItem, Paper, Select, Typography } from '@mui/material';
import { countries } from '@frontend/features/common/constants/countries';
import { CountryFlag } from '@frontend/features/common/components/CountryFlag';
import { phoneInputStyles } from './styles';
import { CountrySelectorProps } from './types';

export const CountrySelector = ({ selectedCountry, onCountryChange }: CountrySelectorProps) => (
  <Paper sx={phoneInputStyles.countryPaper}>
    <FormControl>
      <Select
        value={selectedCountry}
        onChange={onCountryChange}
        displayEmpty
        variant="standard"
        disableUnderline
        size="small"
        sx={phoneInputStyles.countrySelect}
        renderValue={(value) => {
          const country = countries.find((c) => c.code === value);
          return country ? (
            <Box sx={phoneInputStyles.countryDisplay}>
              <CountryFlag countryCode={country.code} styles={{ width: 24, height: 24, borderRadius: 2 }} />
              <Typography variant="body2" sx={phoneInputStyles.countryText}>
                +{country.phoneCode}
              </Typography>
            </Box>
          ) : null;
        }}
      >
        {countries
          .filter((country) => country.enable)
          .map((country) => (
            <MenuItem key={country.code} value={country.code}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CountryFlag countryCode={country.code} />
                <Typography variant="body2">{country.name}</Typography>
                <Typography variant="body2" color="text.secondary">
                  +{country.phoneCode}
                </Typography>
              </Box>
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  </Paper>
);
